import { render, staticRenderFns } from "./SeatGroupList.vue?vue&type=template&id=31ac6d06&scoped=true&"
import script from "./SeatGroupList.vue?vue&type=script&lang=js&"
export * from "./SeatGroupList.vue?vue&type=script&lang=js&"
import style0 from "./SeatGroupList.vue?vue&type=style&index=0&id=31ac6d06&scoped=true&lang=css&"
import style1 from "./SeatGroupList.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ac6d06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31ac6d06')) {
      api.createRecord('31ac6d06', component.options)
    } else {
      api.reload('31ac6d06', component.options)
    }
    module.hot.accept("./SeatGroupList.vue?vue&type=template&id=31ac6d06&scoped=true&", function () {
      api.rerender('31ac6d06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chooseSeat/ActivityManage/SeatGroupList.vue"
export default component.exports